;(function($, undefined){

    var rnn = window.rnn,
        log = rnn.logging.log,
        loginForm = '',
        forms;

    function createLoginMessage(message, isError){
        return message && rnn.modules.alert.show(null,{'message':message, 'type':isError && 'error'});
        //return message && $.el.div({'class': 'alert' + (isError && ' alert-error')||''}, message);
    }

    /////////////////////
    // Create Login Form
    /////////////////////

    function createLoginForm(message, isError){
        var loginButton,
            loginForm = $($.el.form({id:'login', 'class':'login', method:'post', action: rnn.site.loginURL},
            $.el.div({'class':'messages'}, createLoginMessage(message, isError)),
            forms.createControlGroup({name: 'username', label:'Username / Email address', placeholder: 'Username / Email address'}),
            forms.createControlGroup({name: 'password', label:'Password', placeholder: 'Password', type: 'password'}),
            $.el.input({type:'hidden', name:'next', value: document.location}),
            loginButton = $.el.button({type:'submit', 'class':'btn btn-primary submitLogin'}, 'Login')
        ));

        loginForm.on('submit', function(event){
            event.preventDefault();

            $(this).find('.alert').remove();

            rnn.modules.user.login(
                $(this).find('[name="username"]').val(),
                $(this).find('[name="password"]').val(),
                event.target
            );
        });

        return loginForm;
    }

    function createCommentLoginForm(title, message, isError, meta){
        var loginButton,
            loginForm = $($.el.form({id:'login', 'class':'login loginCreate', method:'post', action:rnn.site.loginURL},
            $.el.a({'class':'icon-remove cancel'}),
            $.el.h5(title),
            $.el.div({'class':'messages'}, createLoginMessage(message, isError, meta)),
            forms.createControlGroup({name:'username',  placeholder:'Username / Email address'}),
            forms.createControlGroup({name:'password',  placeholder:'Password', type:'password'}),
            $.el.div({'class':'loginBottom'},
                $.el.span({'class':'postLabel'},
                    $.el.label({'class':'emailWhenPublished loginNotify', 'style':!meta.preModerated && 'display:none;'},
                        $.el.input({class:'loginNotify', name:'email_when_published', type:'checkbox', checked:'checked'}),
                        'Notify me by email when my comment is published.'
                    ),
                    $.el.label({'class':'notifyMeOfUpdates loginNotify'},
                        subscribeAttributes = {name:'subscribe_to_conversation', type:'checkbox', class:'loginNotify'},
                        (meta.subscribed && (subscribeAttributes['checked'] = 'checked', null)),
                        $.el.input(subscribeAttributes),
                        'Notify me of updates to this conversation.'
                    )
                ),
                $.el.span({'class':'postButton'},
                  $.el.input({type:'hidden', name:'next', value:document.location}),
                  loginButton = $.el.button({type:'submit', 'id':'submitLogin', 'class':'button-default-dark submitLogin'}, 'Login and Post'),
                  $.el.a({'class':'troubles', href: rnn.site.resetPasswordURL, target:"_blank"}, 'Troubles logging in?')
                )
            )
        ));

        loginForm.on('submit', function(event){
            event.preventDefault();

            $(this).find('.alert').remove();

            rnn.modules.user.login(
                $(this).find('[name="username"]').val(),
                $(this).find('[name="password"]').val(),
                event.target
            );

        });

        return loginForm;
    }

    function createCommentLoginFormMobile(title, message, isError, meta){
            var loginButton,
                loginForm = $($.el.form({id:'login', 'class':'login loginCreate', method:'post', action: rnn.site.loginURL},

                $.el.h5(title),
                $.el.div({'class':'messages'}, createLoginMessage(message, isError, meta)),
                $.el.span({'class':'signinandpost'},'Sign in and post your comment'),
                forms.createControlGroup({name: 'username',  placeholder: 'Username / Email address'}),
                forms.createControlGroup({name: 'password',  placeholder: 'Password', type: 'password'}),
                $.el.div({'class':'loginBottom'},
                    $.el.span({'class':'postLabel'},
                        $.el.label({'class': 'emailWhenPublished loginNotify', 'style':!meta.preModerated &&'display:none;'},
                            $.el.input({class:'loginNotify',name:'email_when_published', type: 'checkbox', checked:'checked'}),
                            'Notify me by email when my comment is published.'
                        ),
                        $.el.label({'class': 'notifyMeOfUpdates loginNotify'},
                            subscribeAttributes = {name:'subscribe_to_conversation', type: 'checkbox', class:'loginNotify'},
                            (meta.subscribed && (subscribeAttributes['checked'] = 'checked', null)),
                            $.el.input(subscribeAttributes),
                            'Notify me of updates to this conversation.'
                        )
                    ),
                    $.el.span({'class':'postButton'},
                      $.el.input({type:'hidden', name:'next', value: document.location}),
                      loginButton = $.el.button({type:'submit', 'id':'submitLogin', 'class':'button-default-dark'}, 'Login and Post'),
                      $.el.a({'class':'troubles', href: rnn.site.resetPasswordURL, target:"_blank"}, 'Troubles logging in?')
                    )
                )
            ));

            loginForm.on('submit', function(event){
                event.preventDefault();

                $(this).find('.alert').remove();

                rnn.modules.user.login(
                    $(this).find('[name="username"]').val(),
                    $(this).find('[name="password"]').val(),
                    event.target
                );

            });

            return loginForm;
    }

    function initialiseInheritedForm(){
        var log = rnn.logging.log,
            maps = rnn.modules.maps,
            forms = rnn.modules.forms,
            Form = forms.Form,
            Field = forms.Field;

        function LoginForm(options){
            this.base.apply(this, arguments);
        }
        LoginForm.prototype = Object.create(Form.prototype);
        LoginForm.prototype.type = "login";
        LoginForm.prototype.constructor = LoginForm;
        LoginForm.prototype.create = function(){
            var form = this.base.prototype.create.apply(this, arguments),
                loginButton,
                loginForm = $(this.element);

            form.registerField({name: 'username', title: 'Username', label:'Username / Email address', placeholder: 'Username / Email address', required: true});
            form.registerField({name: 'password', title: 'Password', label:'Password', placeholder: 'Password', type: 'password', required: true});
            form.registerField({type: 'hidden', name:'next', value: document.location});

            loginForm.append(
                $.el.h3(form.title),
                $.el.div({'class':'messages'}, createLoginMessage(form.message, form.isError)),
                form.fields.username.element,
                form.fields.password.element,
                form.fields.next.element,
                $.el.p({'class':'register'},
                    "Don't have an account? ",
                    $.el.a({href: rnn.site.registerURL}, 'Register here.')
                )
            ).addClass('loginForm');

            return loginForm;
        };
        LoginForm.prototype.submit = function(){
            var form = this,
                errorData = {},
                next = form.nextFieldGenerator(form, function(field, next){
                    field.submit(form, next);
                });

            // check for errors on all form fields,
            // Then mark as done.
            form.eachField(function(field, name, form){
                field.validate();
                var fieldErrors = field.getErrors();

                if(fieldErrors.length){
                    if(!errorData.errors){
                        errorData.errors = {};
                    }
                    errorData.errors[name] = fieldErrors;
                }
            });

            if(errorData.errors){
                form.error(errorData);
                return form;
            }


            // Call .submit() on all form fields,
            // Then mark as done.
            next().done();

            $(form.element).slideUp().find('.alert').remove();

            $(rnn).one('loginError', function(){
                $(form.element).slideDown();
            });

            rnn.modules.user.login(
                this.fields.username.value(),
                this.fields.password.value(),
                this.element
            );

            return form;
        };

        rnn.modules.login.LoginForm = LoginForm;
    }

    function customSelectPlaceHolderColour(){
        if ($("#registration-form").length > 0) {

            $("#registration-form #id_year").change(function () {
                if(!$(this).val()) $(this).addClass("empty");
                else $(this).removeClass("empty");
            });
            $("#registration-form #id_year").change();
        }

        if ($("#edit-profile-form").length > 0) {

            $("#edit-profile-form #id_dob_day").change(function () {
                if($(this).val() == "0") $(this).addClass("empty");
                else $(this).removeClass("empty");
            });
            $("#edit-profile-form #id_dob_day").change();

            $("#edit-profile-form #id_dob_month").change(function () {
                if($(this).val() == "0") $(this).addClass("empty");
                else $(this).removeClass("empty");
            });
            $("#edit-profile-form #id_dob_month").change();

            $("#edit-profile-form #id_dob_year").change(function () {
                if($(this).val() == "0") $(this).addClass("empty");
                else $(this).removeClass("empty");
            });
            $("#edit-profile-form #id_dob_year").change();

        }
    }

    function onBlurChecks(){
        $('#registration-form input, #edit-profile-form input').blur(function() {
            var $this = $(this);
            if($this.val()){
                $this.addClass('filled');
            }else{
                $this.removeClass('filled');
            }
        });

        $('#edit-profile-form input').each(function() {
            var $this = $(this);
            if($this.val()){
                $this.addClass('filled');
            }
        });
    }

    function getFacebookDiv() {
        var divFormFacebook = $.el.div({'class':'only-facebook-api'});
        var para = $.el.p({'class': 'center-text straight-line'});
        $(para).append($.el.span({'class': 'grey-bubble'}, "or"));
        var para1 = $.el.p({'class': 'center-text margin-top-24'});
        var link = $.el.a({'class': 'fb-login-button', 'href': 'javascript:void(0);'}, 'Login with ');
        $(link).append($.el.span({}, 'Facebook'));
        $(para1).append(link);
        $(divFormFacebook).append(para, para1);

        return divFormFacebook;
    }

    function getFacebookHidden() {
        var hiddenFacebook = $.el.input({'type': 'hidden', 'name': 'next', 'value': window.location.pathname, 'id': 'id_next'});

        return hiddenFacebook;
    }

    function loginDisplay(elementType, title) {
        if(!loginForm.length) {
            loginForm = createLoginForm();
            var register = $.el.p({'class': 'new-register'}, 'New? ');
            $(register).append($.el.a({'href': rnn.site.registerURL}, 'Register here'));
            $(register).append($.el.a({'class': 'pull-right', 'href': rnn.site.resetPasswordURL}, 'Forgot password?'));
            $(loginForm).append(getFacebookHidden(), register, getFacebookDiv());
        }

        //if there's more than one login modal - nuke it
        if ($('.loginModal').length > 1) {
            $('.loginModal').last().remove();
        }

        $modal = $('.loginModal');
        if(title) {
            $modal.find('#loginModalLabel').html(title);
        }
        $modal.find('.modal-body').html(loginForm);
        $modal.modal('show'); //bootstrap modal go!
        rnn.modules['facebook'].init();

        //lie in wait to close
        $(rnn).one('login', function(event){
            $('.loginModal').modal('hide');
            if (elementType == "follow topic") {
                rnn.modules.follow.fetchStatus();
            } else if (elementType == "event") {
                rnn.modules.events.updateWithAjax();
            } else if (elementType == "buy photos") {
                rnn.modules.user.get(function(user) {
                    if(!user.first_name || !user.last_name) {
                        rnn.modules.photos.updateProfile(user);
                    } else {
                        rnn.modules.photos.purchase();
                    }
                });
            }
        });
    }

    // Initialise Bootstrap plugins
    function initLogin() {
        forms = window.rnn.modules.forms;

        $(rnn).on('loginError',function(event){
            var loginForm = $(event.target),
                inputFields = loginForm.find('.control-group');

            inputFields.each(function() {
                var $this = $(this),
                    isEmpty = $this.find('input').val().length;

                if(isEmpty <= 0) {
                    $this.addClass('error');
                }
                $this.keypress(function() {
                    $this.removeClass('error');
                });
            });

            loginForm.find('h6').remove();
            loginForm.find('.alert').remove();
            loginForm.find('h5').after(forms.createErrorsAlert(loginForm, event.errors));
            loginForm.find('[name="password"]').val('');
        });

        initialiseInheritedForm();
        customSelectPlaceHolderColour();
        onBlurChecks();
    }

    rnn.modules.register("login", {
        init: initLogin,
        createForm: createLoginForm,
        createCommentForm: createCommentLoginForm,
        createCommentFormMobile: createCommentLoginFormMobile,
        loginDisplay: loginDisplay
    });

})(jQuery);
